module.exports = __webpack_public_path__ + "img/icon-play.c5cfa696.svg";